module.exports = __webpack_public_path__ + "img/call.bedb7c4d.svg";